import './IconLock.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconLock = _ref => {
  let {
    width = 19.778,
    height = 22,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 19.778 22",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock-alt-svgrepo-com",
    d: "M12.889,15.778V18M7.333,10.81c.524-.032,1.17-.032,2-.032h7.111c.83,0,1.476,0,2,.032m-11.111,0a3.752,3.752,0,0,0-1.513.331A3.333,3.333,0,0,0,4.363,12.6C4,13.311,4,14.244,4,16.111v1.556c0,1.867,0,2.8.363,3.513A3.333,3.333,0,0,0,5.82,22.637C6.533,23,7.466,23,9.333,23h7.111c1.867,0,2.8,0,3.513-.363a3.333,3.333,0,0,0,1.457-1.457c.363-.713.363-1.646.363-3.513V16.111c0-1.867,0-2.8-.363-3.513a3.333,3.333,0,0,0-1.457-1.457,3.752,3.752,0,0,0-1.513-.331m-11.111,0V8.556a5.556,5.556,0,1,1,11.111,0V10.81",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#035e88",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1fmljpo"
});
export default IconLock;